<template>
  <div :class="['focus-input', {'focus-input--readonly': readonly}]" @click.stop="clickShowInput">
    <el-input ref="input"
              v-show="showInput"
              @blur="showInput = false"
              v-bind="$attrs"
              v-on="$listeners"></el-input>
    <slot :show-input="showInput"></slot>
  </div>
</template>

<script>
export default {
  name: 'FocusInput',
  props: {
    readonly: Boolean
  },
  data () {
    return {
      showInput: false
    }
  },
  methods: {
    clickShowInput () {
      if (this.readonly) {
        return
      }
      this.showInput = true
      this.$nextTick(() => {
        const input = this.$refs.input
        if (input) {
          input.focus()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.focus-input {
  display: flex;
  align-items: center;
  &--readonly {
    * {
      text-decoration: none !important;
    }
  }
}
</style>
